import InitApp from './InitApp.jsx'

export default InitApp
